import { useEffect, useState } from "react";
import "./Mchat.css";
import { questions } from "../util/mchatQuestions";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularLoading from "../loading/Loading";

const MChat = ({
  setMchatAnsCount,
  handleAnswerChange,
  answers,
  setAnswers,
  setMchatScore,
  id,
  docId,
}) => {
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("s2stoken");
  const navigate = useNavigate();
  const specialYesQuestions = ["q2", "q5", "q12"];

  useEffect(() => {
    const answerCount = Object.values(answers).filter(
      (ans) => ans !== ""
    ).length;
    setMchatAnsCount(answerCount);
  }, [answers, setMchatAnsCount]);

  useEffect(() => {
    const fetchMchat = async () => {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/get_mchat`;
      setLoading(true);
      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: id,
            docId: docId,
          },
        });

        console.log("The API Response is : ", res.data.mchat);

        const ans = res.data.mchat;

        const updated = { ...answers };
        Object.keys(answers).forEach((key) => {
          updated[key] = ans?.[key] || "";
        });
        setAnswers(updated);

        // Recalculate score
        let newScore = 0;
        Object.keys(updated).forEach((key) => {
          if (specialYesQuestions.includes(key) && updated[key] === "yes") {
            newScore++;
          } else if (
            !specialYesQuestions.includes(key) &&
            updated[key] === "no"
          ) {
            newScore++;
          }
        });
        setMchatScore(newScore);
      } catch (error) {
        console.log("Error fetching MCHAT data", error);
        if (error?.response?.data?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMchat();
  }, []);

  if (loading) {
    return <CircularLoading />;
  }

  return (
    <div className="quiz-container">
      <div className="mchat-headerContainer">
        <h1 className="heading">MCHAT</h1>
      </div>
      <div className="question-grid">
        {questions.map((q) => (
          <div key={q.id} className="question">
            <h2>
              {q.id}. {q.question}
            </h2>
            {q.example && <p>For Example: {q.example}</p>}
            <div className="options">
              <label>
                <input
                  type="radio"
                  name={`question-${q.id}`}
                  value="Yes"
                  checked={answers[`q${q.id}`] === "yes"}
                  onChange={() => handleAnswerChange(q.id, "yes")}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name={`question-${q.id}`}
                  value="No"
                  checked={answers[`q${q.id}`] === "no"}
                  onChange={() => handleAnswerChange(q.id, "no")}
                />
                No
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default MChat;
